import { Tree } from '@minoru/react-dnd-treeview';
import { useDocsFavoriteItems } from '@modules/docs/providers/hooks/useDocsFavoriteItems';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { DocsFavoritedItem } from 'src/pages/dashboard/DocsPage/shared/DocsTreeView/DocsFavoritedItem';
import type { TreeItem } from 'src/pages/dashboard/DocsPage/shared/DocsTreeView/types';
import { getAllParentIds } from './DocsTreeView/utils';

export const FavoritesDocsNav = () => {
  const { id: docId } = useParams();
  const favorites = useDocsFavoriteItems();

  const initialOpen = useMemo(() => {
    if (!docId) return false;
    return getAllParentIds(favorites, docId);
  }, [docId, favorites]);

  const renderNode = (node: TreeItem, { depth, isOpen, onToggle }: any) => (
    <div style={{ display: 'flex', paddingLeft: `${depth * 8}px` }}>
      <DocsFavoritedItem node={node} isOpen={isOpen} onToggle={onToggle} />
    </div>
  );

  if (!favorites.length) return null;

  return (
    <Tree
      tree={favorites}
      initialOpen={initialOpen}
      rootId="root"
      render={renderNode}
      sort={false}
      canDrag={() => false}
      canDrop={() => false}
      onDrop={() => {}}
      dropTargetOffset={5}
      listItemComponent="div"
    />
  );
};
